import { useCallback, useState } from 'react';
import { useI18n } from '../i18n';
import { clearAllAppLocalDataAndReload } from '../utils/clearAllAppLocalData';
import styles from './AuthClearAppDataButton.module.css';

export function AuthClearAppDataButton() {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);

  const onClear = useCallback(async () => {
    if (busy) {
      return;
    }
    if (!window.confirm(t('auth.portal.clearAppDataConfirm'))) {
      return;
    }
    setBusy(true);
    try {
      await clearAllAppLocalDataAndReload({ preserveLanguage: true });
    } catch {
      setBusy(false);
    }
  }, [busy, t]);

  const label = busy ? t('auth.portal.clearAppDataBusy') : t('auth.portal.clearAppData');

  return (
    <button
      type="button"
      className={[styles.iconBtn, busy ? styles.iconBtnBusy : ''].filter(Boolean).join(' ')}
      onClick={(event) => {
        event.stopPropagation();
        void onClear();
      }}
      disabled={busy}
      aria-busy={busy}
      aria-label={label}
      title={label}
    >
      <ResetIcon />
    </button>
  );
}

function ResetIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
      <path d="M21 3v5h-5" />
      <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
      <path d="M3 21v-5h5" />
    </svg>
  );
}
